import React from 'react';
import Image from 'next/image';
import { SPINLogo } from '../../svg/SPINLogo';
import { CokeLogo } from '../../svg/partners/CokeLogo';
import { BackgroundImageHome } from '../../backgrounds/BackgroundImageHome';
import Link from 'next/link';
import { useRouter } from 'next/router';

type Props = {
    className?: string;
    icon?: JSX.Element;
    image?: string;
    tabOneTitle: string;
    tabOneRoute: string;
    tabTwoTitle: string;
    tabTwoRoute: string;
    tabThreeTitle: string;
    tabThreeRoute: string;
    imgUrl?: string;
    imgWidth?: number;
    imgHeight?: number;
};

export const PartnersHeaderTabs: React.FC<Props> = ({
    className,
    icon,
    tabOneTitle,
    tabOneRoute,
    tabTwoTitle,
    tabTwoRoute,
    tabThreeTitle,
    tabThreeRoute,
    imgUrl,
    imgWidth,
    imgHeight,
}) => {
    const router = useRouter();

    return (
        <div className={`partner-header${className ? ` ${className}` : ''}`}>
            <div className="container">
                <div className="content-container">
                    {icon && <div className="partner-icon left">{icon}</div>}
                    <div className="partner-image left">
                        {imgUrl && (
                            <BackgroundImageHome
                                imageSrc={imgUrl}
                                altText={''}
                                width={imgWidth ?? 0}
                                height={imgHeight ?? 0}
                                needsPadding={true}
                            />
                        )}
                    </div>
                    <div className="x-sep">{`X`}</div>
                    <div className="partner-icon right">
                        <SPINLogo className="icon spin" />
                    </div>
                </div>
                <div className="partners-navigation">
                    <Link href={`${tabOneRoute}`}>
                        <a className={`partners-link${router.pathname === `${tabOneRoute}` ? ' active' : ''}`}>
                            {tabOneTitle}
                        </a>
                    </Link>
                    <Link href={`${tabTwoRoute}`}>
                        <a className={`partners-link${router.pathname === `${tabTwoRoute}` ? ' active' : ''}`}>
                            {tabTwoTitle}
                        </a>
                    </Link>
                    <Link href={`${tabThreeRoute}`}>
                        <a className={`partners-link${router.pathname === `${tabThreeRoute}` ? ' active' : ''}`}>
                            {tabThreeTitle}
                        </a>
                    </Link>
                </div>
            </div>
        </div>
    );
};
